import { ReactNode } from 'react';

import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import { Body } from 'components/Text/Body';
import { H2 } from 'components/Text/H2';
import { colors, gutterWidth } from 'theme/theme';

type Props = {
  headline?: string | null | undefined;
  subheadline?: string | null | undefined;
  buttonText?: string | null | undefined;
  buttonUrl?: string | null | undefined;
  children: ReactNode;
};

export function CmsAmpCardsBlockCardContainer({
  headline,
  subheadline,
  buttonText,
  buttonUrl,
  children,
}: Props) {
  return (
    <Box
      mx={[-gutterWidth / 2, null, -gutterWidth]}
      p={[gutterWidth / 2, null, gutterWidth]}
      borderRadius={[0, null, null, 48]}
      bg={colors.backgroundGrey}
      textAlign="center"
    >
      {headline && (
        <H2
          dangerouslySetInnerHTML={{
            __html: headline,
          }}
        />
      )}
      {subheadline && (
        <Body
          dangerouslySetInnerHTML={{
            __html: subheadline,
          }}
        />
      )}
      {buttonText && buttonUrl && (
        <AnchorButton href={buttonUrl}>{buttonText}</AnchorButton>
      )}
      <Box
        display="flex"
        justifyContent="center"
        alignItems={['center', null, 'flex-start']}
        flexWrap="wrap"
        flexDirection={['column', null, 'row']}
        mt={headline || subheadline || (buttonText && buttonUrl) ? 48 : 0}
      >
        {children}
      </Box>
    </Box>
  );
}
